import { CustomPortableText } from '@workspace/ui/PortableText';

export const renderBody = (body: any) => {
  const bodyArray = Array.isArray(body) ? body : [];
  if (bodyArray.length > 0) {
    return (
      <div className="prose prose-gray max-w-none">
        <CustomPortableText value={bodyArray} />
      </div>
    );
  }

  return null;
};
